export enum PersonType {
	Public = 10,
	Staff = 20,
    Contractor = 30
}